// extracted by mini-css-extract-plugin
export default {"side-title-container":"j2MHw","sideTitleContainer":"j2MHw","side-title-heading":"T1Dqx","sideTitleHeading":"T1Dqx","side-subtitle":"_2i-Y5","sideSubtitle":"_2i-Y5"};